module.exports = __webpack_public_path__ + "static/media/whl.a294fbf2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/displayBoard/whl.svg
// module id = 4475
// module chunks = 0